import data from "../data";
import columns from "./tableColumns";
import columnsG from "./tableColumnsGenerated";
import { Spin, Table } from "antd";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import SearchInput from "./search";
import GenerateXML from "./GenerateXML";
import { useContext } from "react";
import ShowGenerated from "./ShowGenerated";
import { usePaginationRezerwy } from "../../../context/PaginationContextRezerwy";
const WplywyTable = () => {
    const { pagination, setPagination } = usePaginationRezerwy();
    const navigate = useNavigate();
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);

    const handleRowClick = (record) => {
        navigate(`/rezerwy/${record.key}`)
    };

    // Handle row selection
    const onSelectChange = (selectedKeys) => {
        setSelectedRowKeys(selectedKeys);
    };

    // Define rowSelection property for Table
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        getCheckboxProps: (record) => ({
            disabled: !!record.msr_generated_files_id, // Disable checkbox if msr_generated_files_id exists
        }),
    };

    const handleTableChange = (paginationInfo) => {
        const { current, pageSize } = paginationInfo;
        setPagination((prev) => ({
            ...prev,
            current, // Update the current page
            pagesize: pageSize, // Update the page size
        }));
    };

    const rows = data();

    return (
        <>
            <div
                className="table-header"
                style={{
                    display: "flex",
                    gap: "10px",
                    marginBottom: "16px",
                    padding: "20px",
                    paddingBottom: "0",
                }}
            >
                <SearchInput></SearchInput>
            </div>
            <div className="table-body" style={{ padding: "20px", paddingTop: "0" }}>
                <Spin spinning={pagination.loading}>
                    <Table
                        columns={pagination.generated ? columns : columnsG}
                        onChange={handleTableChange} // Handle pagination changes
                        dataSource={rows.data}
                        loading={pagination.loading}
                        expandIcon={false}
                        pagination={{
                            current: pagination.current,
                            pageSize: pagination.pagesize,
                            total: rows.total, // Replace with total number of records from your server
                            showSizeChanger: true, // Allows changing the page size
                            pageSizeOptions: ["1", "10", "20", "50", "100"]
                        }}
                        onRow={(record) => ({
                            onClick: () => handleRowClick(record),
                        })}
                    />
                </Spin>
            </div>
        </>
    );
};

export default WplywyTable;
